import React from 'react';

export default function Logo({ size = 40, showText = true, className = '' }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="logo">
      <svg
        width={size}
        height={size}
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="drop-shadow-[0_0_8px_rgba(34,211,238,0.6)]"
      >
        {/* Main gear */}
        <g stroke="#22D3EE" strokeWidth="3" fill="none">
          <circle cx="35" cy="40" r="14" />
          <circle cx="35" cy="40" r="6" />
          {/* Gear teeth main */}
          {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, i) => {
            const rad = (angle * Math.PI) / 180;
            const x1 = 35 + Math.cos(rad) * 16;
            const y1 = 40 + Math.sin(rad) * 16;
            const x2 = 35 + Math.cos(rad) * 21;
            const y2 = 40 + Math.sin(rad) * 21;
            return <line key={`g1-${i}`} x1={x1} y1={y1} x2={x2} y2={y2} />;
          })}
        </g>
        {/* Secondary gear top right */}
        <g stroke="#22D3EE" strokeWidth="2.5" fill="none">
          <circle cx="62" cy="28" r="9" />
          <circle cx="62" cy="28" r="3.5" />
          {[0, 60, 120, 180, 240, 300].map((angle, i) => {
            const rad = (angle * Math.PI) / 180;
            const x1 = 62 + Math.cos(rad) * 10;
            const y1 = 28 + Math.sin(rad) * 10;
            const x2 = 62 + Math.cos(rad) * 14;
            const y2 = 28 + Math.sin(rad) * 14;
            return <line key={`g2-${i}`} x1={x1} y1={y1} x2={x2} y2={y2} />;
          })}
        </g>
        {/* Third gear bottom right */}
        <g stroke="#22D3EE" strokeWidth="2.5" fill="none">
          <circle cx="58" cy="68" r="8" />
          <circle cx="58" cy="68" r="3" />
          {[0, 60, 120, 180, 240, 300].map((angle, i) => {
            const rad = (angle * Math.PI) / 180;
            const x1 = 58 + Math.cos(rad) * 9;
            const y1 = 68 + Math.sin(rad) * 9;
            const x2 = 58 + Math.cos(rad) * 13;
            const y2 = 68 + Math.sin(rad) * 13;
            return <line key={`g3-${i}`} x1={x1} y1={y1} x2={x2} y2={y2} />;
          })}
        </g>
      </svg>
      {showText && (
        <span
          className="text-xl font-light tracking-wide text-[#22D3EE]"
          style={{
            fontFamily: 'Outfit, sans-serif',
            textShadow: '0 0 12px rgba(34,211,238,0.5)',
          }}
        >
          Done Technology
        </span>
      )}
    </div>
  );
}
